module.exports = __webpack_public_path__ + "img/pennellata-left.8baa3cfc.jpg";